<template>
    <el-dialog :class="`merge-dialog`" title="Create Team" :visible.sync="showModal" width="500px">
        <div slot="title" :class="`d-flex justify-content-between align-items-center`">Switch Team</div>
        <div class="row group-class">
            <div class="col-12">
                <el-select v-model="currentTeam" name="team-members" value-key="id" :class="`w-100`"
                           placeholder="Select Team">
                    <el-option label="Default" :value="0"></el-option>
                    <el-option v-for="team in userTeams" :key="team.id" :label="team.name" :value="team.id"></el-option>
                </el-select>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
			<el-button @click="showModal = false">Cancel</el-button>
			<el-button type="success" @click="switchTeam">Switch Team</el-button>
		</span>
    </el-dialog>
</template>

<script>
export default {
    name: "TeamSwitcher",
    data() {
        return {
            currentTeam: null,
            showModal: false,
            sortedTeamName: [],
        }
    },
    mounted() {
        this.$bus.$on("toggle-team-switcher", () => {
            this.showModal = true
        })
        this.currentTeam = _.get(Ambition.Globals, "tenant.user.current_team_id", 0) || 0
    },
    computed: {
        userTeams() {
            var userTeams = _.get(Ambition.Globals, "tenant.user.teams", []);

            if (!userTeams.length && Ambition.hasRoleOrPermission(["administrator"])) {
                this.sortedTeamName =  _.get(Ambition.Globals, "tenant.teams", []);
                return this.sortedTeamName ? _.sortBy(this.sortedTeamName, "name") : [];
            }

            this.sortedTeamName =  _.get(Ambition.Globals, "tenant.teams", []);
            return this.sortedTeamName ? _.sortBy(this.sortedTeamName, "name") : [];
        },
    },
    methods: {
        switchTeam() {
            window.location.href = parseInt(this.currentTeam) > 0
                ? "/admin/switch_team/" + this.currentTeam
                : "/admin/switch_team_default";
        },
    },
}
</script>

<style lang="scss">
</style>
